import { render } from "./config-provider.vue?vue&type=template&id=320a6888"
import script from "./config-provider.vue?vue&type=script&lang=js"
export * from "./config-provider.vue?vue&type=script&lang=js"

import exportComponent from "F:\\code\\flash-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__